export default __webpack_public_path__ + "static/media/send-score-button.7fb83b35.svg";